import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ITedarikciList_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITedarikciList_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  Boss_VVendor: any[];
  Boss_VVendor_dummy: any[];
  Boss_VVendorHeader: any[];
  Boss_VVendorHeader_dummy: any[];
  Boss_VVendorTotal: any[];
  Boss_VVendorTotal_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp115365Visible: "visible" | "hidden";
  isComp330937Visible: "visible" | "hidden";
}

export class TedarikciList_ScreenBase extends React.PureComponent<
  ITedarikciList_ScreenProps,
  any
> {
  tedarikcilist_52192_value_kuikaSelectBoxRef: React.RefObject<any>;
  tedarikcilist_222385_value_kuikaTableRef: React.RefObject<any>;
  tedarikcilist_12409_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "2ad9d4fe-a05d-4582-94f1-0f2efee69eda",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 562712, PropertyName: "label", Value: "Profil" },
        { Id: 473405, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 938173, PropertyName: "value", Value: "Tedarikçi Hesapları" },
        { Id: 588216, PropertyName: "value", Value: "Varlıklarım / Borçlarım" },
        { Id: 450762, PropertyName: "value", Value: "Alacaklarım" },
        { Id: 179082, PropertyName: "value", Value: "Borçlarım" },
        { Id: 834055, PropertyName: "value", Value: "Net Varlık" },
        { Id: 52192, PropertyName: "placeholder", Value: "Borç/Alacak bakiye" },
        { Id: 542451, PropertyName: "placeholder", Value: "Unvan..." },
        { Id: 31976, PropertyName: "label", Value: "Ara" },
        { Id: 950435, PropertyName: "label", Value: "Temizle" },
        {
          Id: 222385,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 627176, PropertyName: "title", Value: "Title" },
        { Id: 593319, PropertyName: "value", Value: "Kod" },
        { Id: 480138, PropertyName: "value", Value: "[datafield:accountcode]" },
        { Id: 389949, PropertyName: "value", Value: "Unvan" },
        {
          Id: 523286,
          PropertyName: "value",
          Value: "[datafield:accountdescription]",
        },
        { Id: 487479, PropertyName: "value", Value: "Para Birimi" },
        {
          Id: 707390,
          PropertyName: "value",
          Value: "[datafield:doccurrencycode]",
        },
        { Id: 577040, PropertyName: "value", Value: "Bakiye" },
        { Id: 294943, PropertyName: "value", Value: "[datafield:balance]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.tedarikcilist_52192_value_kuikaSelectBoxRef = React.createRef();
    this.tedarikcilist_542451_value_kuikaTextInputRef = React.createRef();
    this.tedarikcilist_222385_value_kuikaTableRef = React.createRef();
    this.tedarikcilist_12409_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      Boss_VVendor: [],
      Boss_VVendorHeader: [],
      Boss_VVendorTotal: [],
      GetImage: [],
      SetValueOf: "",
      dataSource_52192: [
        { key: "0", text: "Tümü" },
        { key: "1", text: "Borç Bakiyeliler" },
        { key: "2", text: "Alacak Bakiyeliler" },
      ],
      isComp115365Visible: "hidden",
      isComp330937Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("tedarikcilist", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.TedarikciListPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("tedarikcilist", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("tedarikcilist", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TedarikciListPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      tedarikcilist_772744_value:
        this.state.GetImage?.at?.(0)?.photo ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  TedarikciListPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("0", "string"),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TedarikciList/TedarikciListPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VVendor = result?.data.boss_VVendor;

    stateVars.Boss_VVendorHeader = result?.data.boss_VVendorHeader;

    stateVars.Boss_VVendorTotal = result?.data.boss_VVendorTotal;
    formVars.tedarikcilist_487160_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VVendorTotal !== undefined
        ? stateVars.Boss_VVendorTotal?.length > 0
          ? stateVars.Boss_VVendorTotal[0].debitBalance
          : null
        : this.state.Boss_VVendorTotal?.length > 0
        ? this.state.Boss_VVendorTotal[0].debitBalance
        : null
    );
    formVars.tedarikcilist_81616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VVendorTotal !== undefined
        ? stateVars.Boss_VVendorTotal?.length > 0
          ? stateVars.Boss_VVendorTotal[0].creditBalance
          : null
        : this.state.Boss_VVendorTotal?.length > 0
        ? this.state.Boss_VVendorTotal[0].creditBalance
        : null
    );
    formVars.tedarikcilist_416512_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VVendorTotal !== undefined
        ? stateVars.Boss_VVendorTotal?.length > 0
          ? stateVars.Boss_VVendorTotal[0].balance
          : null
        : this.state.Boss_VVendorTotal?.length > 0
        ? this.state.Boss_VVendorTotal[0].balance
        : null
    );
    stateVars.GetImage = result?.data.getImage;
    formVars.tedarikcilist_772744_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TedarikciListPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TedarikciListPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.tedarikcilist_772744_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    stateVars.dataSource_538619 =
      stateVars.Boss_VVendorHeader ?? this.state.Boss_VVendorHeader;
    formVars.tedarikcilist_487160_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VVendorTotal !== undefined
        ? stateVars.Boss_VVendorTotal?.length > 0
          ? stateVars.Boss_VVendorTotal[0].debitBalance
          : null
        : this.state.Boss_VVendorTotal?.length > 0
        ? this.state.Boss_VVendorTotal[0].debitBalance
        : null
    );

    formVars.tedarikcilist_81616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VVendorTotal !== undefined
        ? stateVars.Boss_VVendorTotal?.length > 0
          ? stateVars.Boss_VVendorTotal[0].creditBalance
          : null
        : this.state.Boss_VVendorTotal?.length > 0
        ? this.state.Boss_VVendorTotal[0].creditBalance
        : null
    );

    formVars.tedarikcilist_416512_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VVendorTotal !== undefined
        ? stateVars.Boss_VVendorTotal?.length > 0
          ? stateVars.Boss_VVendorTotal[0].balance
          : null
        : this.state.Boss_VVendorTotal?.length > 0
        ? this.state.Boss_VVendorTotal[0].balance
        : null
    );

    stateVars.dataSource_222385 =
      stateVars.Boss_VVendor ?? this.state.Boss_VVendor;
    formVars.tedarikcilist_12409_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendor !== undefined
        ? stateVars.Boss_VVendor?.length > 0
          ? stateVars.Boss_VVendor[0].totalCount
          : null
        : this.state.Boss_VVendor?.length > 0
        ? this.state.Boss_VVendor[0].totalCount
        : null
    );
    formVars.tedarikcilist_12409_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendor !== undefined
        ? stateVars.Boss_VVendor?.length > 0
          ? stateVars.Boss_VVendor[0].pageCount
          : null
        : this.state.Boss_VVendor?.length > 0
        ? this.state.Boss_VVendor[0].pageCount
        : null
    );

    formVars.tedarikcilist_12409_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendor !== undefined
        ? stateVars.Boss_VVendor?.length > 0
          ? stateVars.Boss_VVendor[0].totalCount
          : null
        : this.state.Boss_VVendor?.length > 0
        ? this.state.Boss_VVendor[0].totalCount
        : null
    );
    formVars.tedarikcilist_12409_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendor !== undefined
        ? stateVars.Boss_VVendor?.length > 0
          ? stateVars.Boss_VVendor[0].pageCount
          : null
        : this.state.Boss_VVendor?.length > 0
        ? this.state.Boss_VVendor[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TedarikciListComponent_961468_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TedarikciList",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "773981",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TedarikciListComponent_562712_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TedarikciList",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TedarikciListComponent_473405_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TedarikciListComponent_52192_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tedarikcilist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tedarikcilist_52192_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TedarikciList/TedarikciListComponent_52192_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VVendor = result?.data.boss_VVendor;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TedarikciListComponent_52192_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TedarikciListComponent_52192_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tedarikcilist_12409_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_222385 =
      stateVars.Boss_VVendor ?? this.state.Boss_VVendor;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TedarikciListComponent_31976_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tedarikcilist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tedarikcilist_52192_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TedarikciList/TedarikciListComponent_31976_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VVendor = result?.data.boss_VVendor;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TedarikciListComponent_31976_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TedarikciListComponent_31976_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_222385 =
      stateVars.Boss_VVendor ?? this.state.Boss_VVendor;
    formVars.tedarikcilist_12409_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendor !== undefined
        ? stateVars.Boss_VVendor?.length > 0
          ? stateVars.Boss_VVendor[0].totalCount
          : null
        : this.state.Boss_VVendor?.length > 0
        ? this.state.Boss_VVendor[0].totalCount
        : null
    );
    formVars.tedarikcilist_12409_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendor !== undefined
        ? stateVars.Boss_VVendor?.length > 0
          ? stateVars.Boss_VVendor[0].pageCount
          : null
        : this.state.Boss_VVendor?.length > 0
        ? this.state.Boss_VVendor[0].pageCount
        : null
    );

    formVars.tedarikcilist_12409_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendor !== undefined
        ? stateVars.Boss_VVendor?.length > 0
          ? stateVars.Boss_VVendor[0].totalCount
          : null
        : this.state.Boss_VVendor?.length > 0
        ? this.state.Boss_VVendor[0].totalCount
        : null
    );
    formVars.tedarikcilist_12409_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendor !== undefined
        ? stateVars.Boss_VVendor?.length > 0
          ? stateVars.Boss_VVendor[0].pageCount
          : null
        : this.state.Boss_VVendor?.length > 0
        ? this.state.Boss_VVendor[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TedarikciListComponent_950435_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tedarikcilist_542451_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tedarikcilist_52192_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("0", "string"),
      null,
      "Key"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tedarikcilist_12409_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TedarikciListComponent_950435_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TedarikciListComponent_950435_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("0", "string"),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TedarikciList/TedarikciListComponent_950435_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VVendor = result?.data.boss_VVendor;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TedarikciListComponent_950435_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TedarikciListComponent_950435_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_222385 =
      stateVars.Boss_VVendor ?? this.state.Boss_VVendor;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TedarikciListComponent_91072_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TedarikciDetay",
      "CustomerCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "tedarikcilist_222385_value",
          "accountCode"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TedarikciDetay",
      "CustomerName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "tedarikcilist_222385_value",
          "accountDescription"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TedarikciList",
      "TedarikciDetay",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TedarikciListComponent_12409_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tedarikcilist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tedarikcilist_52192_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tedarikcilist_12409_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TedarikciList/TedarikciListComponent_12409_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VVendor = result?.data.boss_VVendor;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TedarikciListComponent_12409_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TedarikciListComponent_12409_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_222385 =
      stateVars.Boss_VVendor ?? this.state.Boss_VVendor;
    formVars.tedarikcilist_12409_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendor !== undefined
        ? stateVars.Boss_VVendor?.length > 0
          ? stateVars.Boss_VVendor[0].totalCount
          : null
        : this.state.Boss_VVendor?.length > 0
        ? this.state.Boss_VVendor[0].totalCount
        : null
    );
    formVars.tedarikcilist_12409_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendor !== undefined
        ? stateVars.Boss_VVendor?.length > 0
          ? stateVars.Boss_VVendor[0].pageCount
          : null
        : this.state.Boss_VVendor?.length > 0
        ? this.state.Boss_VVendor[0].pageCount
        : null
    );

    formVars.tedarikcilist_12409_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendor !== undefined
        ? stateVars.Boss_VVendor?.length > 0
          ? stateVars.Boss_VVendor[0].totalCount
          : null
        : this.state.Boss_VVendor?.length > 0
        ? this.state.Boss_VVendor[0].totalCount
        : null
    );
    formVars.tedarikcilist_12409_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendor !== undefined
        ? stateVars.Boss_VVendor?.length > 0
          ? stateVars.Boss_VVendor[0].pageCount
          : null
        : this.state.Boss_VVendor?.length > 0
        ? this.state.Boss_VVendor[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [773981, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TedarikciListPageInit();
    }
  }
}
